/* global gtag_report_conversion */
import React, { useEffect, useState } from "react";

import "../styles/aboutus.css";
import "../styles/common.css";
import { FiPhone, FiMapPin } from "react-icons/fi";

import { ReactComponent as BrakeIcon } from "../images/brake_icon.svg";
import { ReactComponent as OilIcon } from "../images/oil.svg";
import { ReactComponent as MechanichIcon } from "../images/mechanic.svg";
import { ReactComponent as CheckmarkIcon } from "../images/checkmark.svg";

import AOS from "aos";
import "aos/dist/aos.css";

const AboutUs = () => {
  useEffect(() => {
    AOS.init({
      duration: 700, // animation length (ms)
      once: true, // animate only once
      offset: 80, // trigger offset
      easing: "ease-out", // smooth easing
    });
    // In case of late-loaded images
    const onLoad = () => AOS.refresh();
    window.addEventListener("load", onLoad);
    return () => window.removeEventListener("load", onLoad);
  }, []);

  return (
    <section className="aboutus-section pt-5" id="about" data-aos="fade-up">
      <div className="container">
        <h2 className="h2-header text-center" data-aos="fade-up">
          Miért minket válasszon olajcserére vagy fékcserére Szolnokon?
        </h2>
        <div className="divider" data-aos="zoom-in" data-aos-delay="100">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <div className="row align-items-center mt-5">
          <div
            className="col-lg-5 text-center mb-4 mb-lg-0"
            data-aos="fade-right"
            data-aos-delay="150"
          >
            <img
              src="/images/about-us.webp"
              alt="About Us"
              className="aboutus-image"
              onLoad={() => AOS.refresh()}
            />
          </div>

          <div className="col-lg-7" data-aos="fade-left" data-aos-delay="150">
            <div className="text-center mb-4">
              <BrakeIcon
                className="aboutus-icon"
                data-aos="fade-up"
                data-aos-delay="0"
              />
              <OilIcon
                className="aboutus-icon"
                data-aos="fade-up"
                data-aos-delay="100"
              />
              <MechanichIcon
                className="aboutus-icon"
                data-aos="fade-up"
                data-aos-delay="200"
              />
            </div>

            <p
              className="aboutus-text pb-2"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              Nálunk az olajcsere, fékcsere és állapotfelmérés nem rutinmunka,
              hanem elhivatottság. Tapasztalt szerelőink gyorsan és precízen
              dolgoznak, kizárólag minőségi anyagokat használva. Korszerű
              eszközparkunkkal biztosítjuk, hogy autója a lehető legjobb kezekbe
              kerüljön.
            </p>

            <div className="d-flex justify-content-center">
              <ul className="aboutus-list">
                <li data-aos="fade-up" data-aos-delay="250">
                  <CheckmarkIcon className="checkmark-icon" />
                  Gyors időpontadás – akár még aznap elvégezzük
                </li>
                <li data-aos="fade-up" data-aos-delay="300">
                  <CheckmarkIcon className="checkmark-icon" />
                  Átlátható árak, rejtett költségek nélkül
                </li>
                <li data-aos="fade-up" data-aos-delay="350">
                  <CheckmarkIcon className="checkmark-icon" />
                  Szolnoki autószervizként ismerjük a helyi igényeket
                </li>
                <li data-aos="fade-up" data-aos-delay="400">
                  <CheckmarkIcon className="checkmark-icon" />
                  Személyre szabott figyelem, nem futószalagon dolgozunk
                </li>
              </ul>
            </div>

            <div
              className="text-center pb-4"
              data-aos="fade-in"
              data-aos-delay="350"
            >
              <p className="aboutus-location">
                <FiMapPin className="me-2" />
                5000 Szolnok, Véső utca 1.
              </p>
            </div>

            <div
              className="text-center mb-3"
              data-aos="zoom-in-up"
              data-aos-delay="400"
            >
              <a
                href="tel:+36300167381"
                onClick={(e) => {
                  try {
                    if (typeof gtag_report_conversion === "function") {
                      gtag_report_conversion("tel:+36300167381");
                    }
                  } catch (err) {
                    console.error("gtag_report_conversion error:", err);
                  }
                }}
                className="contact-btn d-inline-block"
              >
                <FiPhone className="me-2" />
                Hívjon most: +36 30 016 7381
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="svg-divider">
        <svg
          viewBox="0 0 1440 320"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path fill="#F5F5F5" d="M0,160L720,0L1440,160V0H0Z" />
        </svg>
      </div>
    </section>
  );
};

export default AboutUs;
